import { render } from "./TreeStorageObjectField.vue?vue&type=template&id=fb9190bc"
import script from "./TreeStorageObjectField.vue?vue&type=script&lang=js"
export * from "./TreeStorageObjectField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__